import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { style } from './style';

export enum SpeakerType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DEFAULT = 'default',
}
interface Props {
  imageUrl: string;
  title: string;
  subtitle: string;
  type?: string;
  columns?: number;
}

export const Speaker: FC<Props> = ({ imageUrl, title, subtitle, type = SpeakerType.DEFAULT, columns = 2 }) => {
  const styles = style({ type, columns });
  return (
    <div className={css(styles.container, styles[type])}>
      <img className={css(styles.image)} src={imageUrl} alt='' />
      <span className={css(styles.title)} dangerouslySetInnerHTML={{ __html: title }} />
      <span className={css(styles.subtitle)} dangerouslySetInnerHTML={{ __html: subtitle }} />
    </div>
  );
};
